import React, {Component, ReactElement, ReactNode, RefObject} from 'react'
import NatEventRepo from '../event/repository/NatEventRepo'
import NatCurrentDateTimeRepo from '../currentDateTime/repository/NatCurrentDateTimeRepo'
import NatHolidayMasterRepo from '../holiday/repository/NatHolidayMasterRepo'
import {CurrentDateTime, NatGetCurrentDateTime} from '../currentDateTime/repository/NatGetCurrentDateTime'
import {HolidayMasterInfo, NatGetHolidayMaster} from '../holiday/repository/NatGetHolidayMaster'
import FullCalendar, {CalendarApi, EventApi, EventInput, ViewApi} from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import '@fullcalendar/common/main.css'
import '@fullcalendar/daygrid/main.css'
import {
    getCurrentMonth,
    getCurrentYear,
    getYearAfterNextDate,
    getYearDate,
    NatAsyncCallFunction,
} from '../../common/util/Natutil'
import {EventInfo, NatGetEventList, SearchCondition as EventSearchCondition} from '../event/repository/NatGetEventList'
import {Nullable} from '../../../app/TypeHelpers'
import {EVENT_CATEGORY, VALID_OR_NOT} from '../../../CodeMaster'
import {HKConstants} from '../../../HKConstants'
import styled from 'styled-components'
import {
    StyledDd,
    StyledDiv,
    StyledDl,
    StyledDt,
    StyledI,
    StyledSelect,
} from '../../../styledComponents/StyledTypeDefinitions'
import {formatForDateInput, formatForDateInputDotSeparator} from '../../../formatters/formatDate'
import {
    ContentsMainTitle,
    ContentsSubTitleInner,
    ContentsSubTitleWrapper,
    IconFont,
    MainContainer,
} from '../../../styledComponents/ContentsArea'
import {OptionProps} from '../../../components/shared/forms/PPSelect'
import {LeftRowFlexContainer} from '../../../styledComponents/FlexComponents'
import {BreakPoint, Colors, FontWeights} from '../../../styledComponents/Constants'
import {DisplayItemSelect, DisplayItemSelectIcon} from '../../../styledComponents/DisplayItem'
import {generateMedia} from 'styled-media-query'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage'
import {Location} from 'react-router-dom'

const EVENT_LIMIT_TEXT: string = '件'
const CLICK_DAY_HAVE_NO_EVENT_TEXT: string = 'この日のイベントはありません。'
const EVENT_SEARCH_CONDITION_CONDOMINIUM_EVENT_FLAG: string = '1'

interface CalendarEvent {
    id: string
    title: string
    start: string
    order: number
    color: string
    updateDatetime: string
    className: string
}

interface Props {
    eventRepo: NatEventRepo,
    currentDateTimeRepo: NatCurrentDateTimeRepo
    holidayMasterRepo: NatHolidayMasterRepo
    location: Location,
}

interface States {
    eventList: EventInfo[]
    clickDay: string
    clickDayEventInfo: EventInfo[]
    clickDayFlg: boolean
    currentDateTime: CurrentDateTime
    currentYearMonth: string
    currentDay: string
    holidayMasterInfo: HolidayMasterInfo[]
    eventSearchCondition: EventSearchCondition
    designatedDate: string | null
    isLoadCompleted: boolean
    prevMonthForfullCalendar: string
    nextMonthForfullCalendar: string
    initialDisplay: boolean
}

class NatResidentCalendarPage extends Component<Props & ResidentPagePropsSet, States> {
    calendarRef: RefObject<FullCalendar>

    constructor(props: Props & ResidentPagePropsSet) {
        super(props)

        this.state = {
            eventList: [],
            clickDay: '',
            clickDayEventInfo: [],
            clickDayFlg: false,
            currentDateTime: {
                currentDateTime: '',
                holidayFlag: '',
            },
            currentYearMonth: '',
            currentDay: '',
            holidayMasterInfo: [],
            eventSearchCondition: {},
            designatedDate: null,
            isLoadCompleted: false,
            prevMonthForfullCalendar: '',
            nextMonthForfullCalendar: '',
            initialDisplay: true,
        }
        this.calendarRef = React.createRef()

        this.getEventList = this.getEventList.bind(this)
        this.onClickFullCalendarDate = this.onClickFullCalendarDate.bind(this)
        this.onClickFullCalendarEvent = this.onClickFullCalendarEvent.bind(this)
        this.onChangeYearMonth = this.onChangeYearMonth.bind(this)
        this.judgeDipPrevIcon = this.judgeDipPrevIcon.bind(this)
        this.judgeDipNextIcon = this.judgeDipNextIcon.bind(this)
        this.onClickPrevIcon = this.onClickPrevIcon.bind(this)
        this.onClickNextIcon = this.onClickNextIcon.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            // 現在日時取得
            const currentDateTime: Nullable<NatGetCurrentDateTime> = await NatAsyncCallFunction(
                this.props.currentDateTimeRepo.getCurrentDateTime.bind(
                    this.props.currentDateTimeRepo), this.props.navigate)

            if (currentDateTime && currentDateTime.details) {
                const currentYearMonth: string = getCurrentYear(`${currentDateTime.details.currentDateTime}+09:00`) +
                    '-' + ('0' + String(getCurrentMonth(`${currentDateTime.details.currentDateTime}+09:00`))).slice(-2)

                this.setState({
                    currentDateTime: currentDateTime.details,
                    currentDay: formatForDateInput(`${currentDateTime.details.currentDateTime}+09:00`),
                    currentYearMonth: currentYearMonth,
                    clickDay: formatForDateInput(`${currentDateTime.details.currentDateTime}+09:00`),
                })

            }
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
    }

    async setHoliday(startYearMonth: string, endYearMonth: string): Promise<void> {

        const res: Nullable<NatGetHolidayMaster> = await NatAsyncCallFunction(
            this.props.holidayMasterRepo.getHolidayMaster.bind(
                this.props.holidayMasterRepo, startYearMonth, endYearMonth), this.props.navigate)
        if (res && res.details) {
            this.setState({
                holidayMasterInfo: res.details.holidayMasterInfo,
            })
        }
    }

    async getEventList(info: EventInput): Promise<CalendarEvent[]> {
        if (!this.state.initialDisplay) {
            await this.props.eventEmitter.showLoading()
        }
        try {
            const calendarStartDate = info.startStr.slice(0, 10)
            const calendarEndDate = info.endStr.slice(0, 10)
            const eventListForFullCalendar: CalendarEvent[] = []

            const prevMonthForfullCalendar = new Date(calendarStartDate)
            const nextMonthForfullCalendar = new Date(calendarStartDate)

            if (calendarStartDate.slice(-2) !== '01') {
                nextMonthForfullCalendar.setMonth(nextMonthForfullCalendar.getMonth() + 2)
            } else {
                prevMonthForfullCalendar.setMonth(prevMonthForfullCalendar.getMonth() - 1)
                nextMonthForfullCalendar.setMonth(nextMonthForfullCalendar.getMonth() + 1)
            }

            const startYearMonth = calendarStartDate.slice(0, 7)
            const endYearMonth = calendarEndDate.slice(0, 7)

            await this.setHoliday(calendarStartDate, calendarEndDate)

            this.setState({
                prevMonthForfullCalendar: String(prevMonthForfullCalendar.getMonth() + 1),
                nextMonthForfullCalendar: String(nextMonthForfullCalendar.getMonth() + 1),
            })

            // イベント一覧取得検索条件
            const eventSearchCondition: EventSearchCondition = {}

            // イベント一覧取得検索条件(個別物件向けの情報取得フラグ)
            eventSearchCondition.condominiumEventFlag = EVENT_SEARCH_CONDITION_CONDOMINIUM_EVENT_FLAG
            // イベント一覧取得検索条件(日程開始日)
            eventSearchCondition.scheduleStartDate = calendarStartDate
            // イベント一覧取得検索条件(日程終了日)
            eventSearchCondition.scheduleEndDate = calendarEndDate

            // イベント一覧取得API呼び出し
            const getEventListResponse: Nullable<NatGetEventList> = await NatAsyncCallFunction(
                this.props.eventRepo.getEventList.bind(
                    this.props.eventRepo, eventSearchCondition, undefined, undefined), this.props.navigate)

            if (getEventListResponse && getEventListResponse.details) {
                // 並び順未登録、登録に分ける
                const noSortOrderEvent: EventInfo[] = []
                const sortOrderEvent: EventInfo[] = []
                getEventListResponse.details.eventInfo.map((eventInfo) => {
                    if (eventInfo.invisible === VALID_OR_NOT.NOT.value) {
                        if (eventInfo.sortOrder) {
                            sortOrderEvent.push(eventInfo)
                        } else {
                            noSortOrderEvent.push(eventInfo)
                        }
                    }
                })
                // 並び順でソート
                sortOrderEvent.sort((a, b) =>
                    Number(a.sortOrder) - Number(b.sortOrder))
                // 更新日時でソート
                noSortOrderEvent.sort((a, b) =>
                    Number(new Date(b.updateDatetime)) - Number(new Date(a.updateDatetime)))
                const eventList: EventInfo[] = noSortOrderEvent.concat(sortOrderEvent)

                eventList.map((eventInfo) => {
                    eventListForFullCalendar.push(
                        {
                            id: eventInfo.scheduleId,
                            title: eventInfo.title,
                            start: eventInfo.operationDate,
                            order: eventInfo.sortOrder ? eventInfo.sortOrder : 0,
                            color: eventInfo.barColorSetting,
                            updateDatetime: eventInfo.updateDatetime,
                            className: 'eventCategoryIcon_' + eventInfo.eventCategory,
                        },
                    )
                })
                this.setState({eventList: eventList, initialDisplay: false})
            }
            return eventListForFullCalendar
        } finally {
            if (!this.state.initialDisplay) {
                this.props.eventEmitter.closeLoading()
            }
        }
    }

    onClickFullCalendarDate(arg: {
        date: Date;
        dateStr: string;
        allDay: boolean;
        resource?: any;
        dayEl: HTMLElement;
        jsEvent: MouseEvent;
        view: ViewApi;
    }): void {
        // クリックした日付のイベントを取得する
        const clickDayEventInfo: EventInfo[] = []
        this.state.eventList.map((eventInfo) => {
            if (eventInfo.operationDate === arg.dateStr) {
                clickDayEventInfo.push(eventInfo)
            }
        })
        this.setState({
            clickDayEventInfo: clickDayEventInfo,
            clickDay: arg.dateStr,
            clickDayFlg: true,
        })
    }

    onClickFullCalendarEvent(arg: {
        el: HTMLElement;
        event: EventApi
        jsEvent: MouseEvent;
        view: ViewApi;
    }): void {
        if (!arg.event || !arg.event._instance || !arg.event._instance.range || !arg.event._instance.range.start) {
            return
        } else {
            const clickEventDate: string =
                String(arg.event &&
                    arg.event._instance &&
                    arg.event._instance.range &&
                    arg.event._instance.range.start)
            // クリックしたイベントと同じ日のイベントを取得する
            const clickDayEventInfo: EventInfo[] = []
            this.state.eventList.map((eventInfo) => {
                if (eventInfo.operationDate === formatForDateInput(clickEventDate)) {
                    clickDayEventInfo.push(eventInfo)
                }
            })
            this.setState({
                clickDayEventInfo: clickDayEventInfo,
                clickDay: formatForDateInput(clickEventDate),
                clickDayFlg: true,
            })
        }
    }

    onChangeYearMonth(event: React.ChangeEvent<{ value: unknown }>): void {
        this.setState({
            designatedDate: event.target.value as string,
            clickDay: event.target.value as string + '-01',
            clickDayFlg: false,
        })

        if (this.calendarRef && this.calendarRef.current) {
            const calendarApi: CalendarApi = this.calendarRef.current.getApi()
            calendarApi.gotoDate(event.target.value as string)
        }

    }

    onClickPrevIcon(): void {
        const dispYearMonth =
            new Date(this.state.designatedDate ? this.state.designatedDate : this.state.currentYearMonth)
        dispYearMonth.setMonth(dispYearMonth.getMonth() - 1)

        this.setState({
            designatedDate: dispYearMonth.getFullYear() + '-' + ('0' + String(dispYearMonth.getMonth() + 1)).slice(-2),
            clickDay: dispYearMonth.getFullYear() + '-' + ('0' + String(dispYearMonth.getMonth() + 1)).slice(-2) +
                '-01',
            clickDayFlg: false,
        })

        if (this.calendarRef && this.calendarRef.current) {
            const calendarApi: CalendarApi = this.calendarRef.current.getApi()
            calendarApi.prev()
        }
    }

    onClickNextIcon(): void {
        const dispYearMonth =
            new Date(this.state.designatedDate ? this.state.designatedDate : this.state.currentYearMonth)
        dispYearMonth.setMonth(dispYearMonth.getMonth() + 1)

        this.setState({
            designatedDate: dispYearMonth.getFullYear() + '-' + ('0' + String(dispYearMonth.getMonth() + 1)).slice(-2),
            clickDay: dispYearMonth.getFullYear() + '-' + ('0' + String(dispYearMonth.getMonth() + 1)).slice(-2) +
                '-01',
            clickDayFlg: false,
        })

        if (this.calendarRef && this.calendarRef.current) {
            const calendarApi: CalendarApi = this.calendarRef.current.getApi()
            calendarApi.next()
        }
    }


    judgeDipPrevIcon(): boolean {
        const fullCalendarStartDate = new Date(getYearDate())
        const dispYearMonth = this.state.designatedDate ? this.state.designatedDate : this.state.currentYearMonth
        return fullCalendarStartDate.getFullYear() +
            '-' + ('0' + String(fullCalendarStartDate.getMonth() + 1)).slice(-2) !== dispYearMonth
    }

    judgeDipNextIcon(): boolean {
        const fullCalendarEndDate =
            new Date(getYearAfterNextDate(`${this.state.currentDateTime.currentDateTime}+09:00`))
        const dispYearMonth = this.state.designatedDate ? this.state.designatedDate : this.state.currentYearMonth
        return fullCalendarEndDate.getFullYear() + '-' +
            ('0' + String(fullCalendarEndDate.getMonth() + 1)).slice(-2) !== dispYearMonth
    }


    renderSelect(): Nullable<ReactNode> {
        const yearMonthList: OptionProps[] = []
        const fullCalendarStartDate = new Date(getYearDate())
        const fullCalendarEndDate =
            new Date(getYearAfterNextDate(`${this.state.currentDateTime.currentDateTime}+09:00`))
        let someMonth: number
        someMonth = (fullCalendarEndDate.getFullYear() - fullCalendarStartDate.getFullYear()) * 12
        someMonth = someMonth - (fullCalendarStartDate.getMonth() + 1)
        someMonth = someMonth + fullCalendarEndDate.getMonth() + 1
        for (let count: number = 0; count <= someMonth; count++) {
            yearMonthList.push({
                label: fullCalendarStartDate.getFullYear() + '年' + (fullCalendarStartDate.getMonth() + 1) + '月',
                value: fullCalendarStartDate.getFullYear() + '-' +
                    ('0' + String(fullCalendarStartDate.getMonth() + 1)).slice(-2),
            })
            fullCalendarStartDate.setMonth(fullCalendarStartDate.getMonth() + 1)
        }

        const selectDate = this.state.designatedDate ? this.state.designatedDate : this.state.currentYearMonth
        return (
            <CategorySelectIcon>
                <CategorySelect onChange={this.onChangeYearMonth} value={selectDate}>
                    {yearMonthList.map((category, key) => {
                        return (
                            <option key={key} value={category.value}>
                                {category.label}
                            </option>
                        )
                    })}
                </CategorySelect>
            </CategorySelectIcon>
        )
    }

    renderEventList(): Nullable<ReactNode> {
        let eventInfoList: EventInfo[] = []

        if (this.state.clickDayFlg) {
            eventInfoList = this.state.clickDayEventInfo
        } else {
            // クリックした日付のイベントを取得する
            this.state.eventList.map((Info) => {
                if (Info.operationDate === this.state.clickDay) {
                    eventInfoList.push(Info)
                }
            })
        }

        return (
            <>
                <EventListInfo>
                    {eventInfoList.length === 0 &&
                        <EventListNone>
                            {CLICK_DAY_HAVE_NO_EVENT_TEXT}
                        </EventListNone>
                    }
                    {eventInfoList.length > 0 &&
                        eventInfoList.map((eventInfo, index) => (
                            <EventList key={`clickDayEventInfo_${index}`}>
                                <EventCategory>
                                    <EventCategoryIcon
                                        categoryId={eventInfo.eventCategory}
                                        color={eventInfo.barColorSetting}/>
                                    {eventInfo.title}
                                </EventCategory>
                                <EventTitle dangerouslySetInnerHTML={{__html: eventInfo.description}}/>
                            </EventList>
                        ))
                    }
                </EventListInfo>
            </>
        )
    }

    render(): ReactElement {
        if (!this.state.isLoadCompleted) {
            return (<></>)
        }

        return (
            <>
                <ContentsMainTitle><TitleIcon/>カレンダー</ContentsMainTitle>
                <ContentsSubTitleWrapper>
                    <ContentsSubTitleInner>
                        カレンダー
                    </ContentsSubTitleInner>
                </ContentsSubTitleWrapper>
                <MainContainer>
                    <SelectYearMonth>
                        <LeftRowFlexContainer>
                            {this.judgeDipPrevIcon() &&
                                <PrevIcon
                                    onClick={() => this.onClickPrevIcon()}
                                />
                            }
                            {!this.judgeDipPrevIcon() &&
                                <PrevIconInactive/>
                            }
                            {this.renderSelect()}

                            {this.judgeDipNextIcon() &&
                                <NextIcon
                                    onClick={() => this.onClickNextIcon()}
                                />
                            }
                            {!this.judgeDipNextIcon() &&
                                <NextIconInactive/>
                            }
                        </LeftRowFlexContainer>
                    </SelectYearMonth>
                    <FullCalendarCss
                        publicHoliday={this.state.holidayMasterInfo}
                        currentDate={formatForDateInput(`${this.state.currentDateTime.currentDateTime}+09:00`)}
                        clickDay={this.state.clickDay}
                    >
                        <FullCalendar
                            headerToolbar={
                                {
                                    left: '',
                                    center: '',
                                    right: '',
                                }
                            }
                            initialDate={
                                this.state.designatedDate ? this.state.designatedDate + '-01' : this.state.currentDay
                            }
                            ref={this.calendarRef}
                            initialView="dayGridMonth"
                            plugins={[dayGridPlugin, interactionPlugin]}
                            events={this.getEventList}
                            locale={'ja'}
                            eventOrder={'order,-updateDatetime'}
                            dateClick={this.onClickFullCalendarDate}
                            eventClick={this.onClickFullCalendarEvent}
                            contentHeight={500}
                            dayMaxEventRows={HKConstants.VRS.NTF.MAX_NUMBER_OF_EVENT_CALENDAR + 1}
                            moreLinkText={EVENT_LIMIT_TEXT}
                            moreLinkHint={''}
                        />
                    </FullCalendarCss>
                    {this.state.clickDay &&
                        <EventListArea>
                            <EventListTitle>
                                {formatForDateInputDotSeparator(this.state.clickDay)}のイベント一覧
                            </EventListTitle>
                            {this.renderEventList()}
                        </EventListArea>
                    }
                </MainContainer>
            </>
        )
    }
}

export default createResidentPage(NatResidentCalendarPage)


// ブレイクポイント
const breakPoint: any = generateMedia({
    sp: `${BreakPoint.Sp}`,
})

interface FullCalendarCssParams {
    publicHoliday: HolidayMasterInfo[];
    currentDate: string
    clickDay: string
}

const getPublicHolidayCss = (props: FullCalendarCssParams) => {
    let styles = ''
    props.publicHoliday.map((publicHolidayInfo) => {
        styles += `
        & .fc-daygrid-day[data-date="${publicHolidayInfo.holidayYearsMonthsDate}"] {background: #ffeded;}
    `
    })
    return styles
}

const setClickDay = (props: FullCalendarCssParams) => {
    let styles = ''
    styles += `
        & .fc-daygrid-day[data-date="${props.clickDay}"] {background: #ebf8fb;}
    `
    return styles
}

const setCurrentDate = (props: FullCalendarCssParams) => {
    let styles = ''
    styles += `
        & .fc-day[data-date="${props.currentDate}"] {background: #fff8d1;}
    `
    return styles
}

const TitleIcon: StyledI = styled.i`
  ${IconFont};
  font-size: 6.0rem;
  padding-right: 15px;
  color: #ffbc47;

  &::before {
      content: "\f10C";
  }
`


const PrevIcon: StyledI = styled.i`
  ${IconFont};
  font-size: 4.0rem;
  padding-right: 15px;
  color: ${Colors.PrimaryActive};
  cursor: pointer;

  &::before {
      content: "\f103";
  }
`

const PrevIconInactive: StyledI = styled.i`
  ${IconFont};
  font-size: 4.0rem;
  padding-right: 15px;
  color: ${Colors.Background};

  &::before {
      content: "\f103";
  }
`

const NextIcon: StyledI = styled.i`
  ${IconFont};
  font-size: 4.0rem;
  padding-left: 15px;
  color: ${Colors.PrimaryActive};
  cursor: pointer;


  &::before {
      content: "\f104";
  }
`

const NextIconInactive: StyledI = styled.i`
  ${IconFont};
  font-size: 4.0rem;
  padding-left: 15px;
  color: ${Colors.Background};

  &::before {
      content: "\f104";
  }
`

const SelectYearMonth: StyledDiv = styled.div`
  [class*=FlexComponents__FlexContainer] {
    justify-content: center;
  }
`
// language=LESS
const FullCalendarCss = styled.div<FullCalendarCssParams>`

  & .fc-view {
    font-size: 0.75em;
  }

  // カレンダーヘッダー用設定
  & .fc-col-header-cell.fc-day-mon, .fc-col-header-cell.fc-day-tue, .fc-col-header-cell.fc-day-wed, .fc-col-header-cell.fc-day-thu, .fc-col-header-cell.fc-day-fri {
    background: #e4e4e4;
  }

  // カレンダー日付用設定
  & .fc-daygrid-day.fc-day-mon, .fc-daygrid-day.fc-day-tue, .fc-daygrid-day.fc-day-wed, .fc-daygrid-day.fc-day-thu, .fc-daygrid-day.fc-day-fri {
    background: #ffffff;
  }

  & .fc-day-sun {
    background: #ffeded;
  }

  & .fc-day-sat {
    background: #ebf9ff;
  }

  // カレンダー日付を左寄せ
  & .fc .fc-daygrid-day-frame .fc-daygrid-day-top {
    float: left !important;
  }

  // 祝日の背景色を変更
  ${(props: FullCalendarCssParams) => getPublicHolidayCss(props)}
    // 選択した日の背景色を変更
  ${(props: FullCalendarCssParams) => setClickDay(props)}
  ${(props: FullCalendarCssParams) => setCurrentDate(props)}
  & .fc-toolbar-chunk {
    display: inline-flex;
  }

  & .fc-event-title-container {
    text-overflow: ellipsis;
  }

  // fullcalendar内アイコン表示
  & .eventCategoryIcon_0 > .fc-event-main > .fc-event-main-frame > .fc-event-title-container::before {
    ${IconFont};
    content: "\f11d";
  }

  & .eventCategoryIcon_1 > .fc-event-main > .fc-event-main-frame > .fc-event-title-container::before {
    ${IconFont};
    content: "\f127";
  }

  & .eventCategoryIcon_2 > .fc-event-main > .fc-event-main-frame > .fc-event-title-container::before {
    ${IconFont};
    content: "\f10e";
  }

  & .eventCategoryIcon_3 > .fc-event-main > .fc-event-main-frame > .fc-event-title-container::before {
    ${IconFont};
    content: "\f12f";
  }

  & .eventCategoryIcon_4 > .fc-event-main > .fc-event-main-frame > .fc-event-title-container::before {
    ${IconFont};
    content: "\f12f";
  }

  ${breakPoint.lessThan('sp')`
 & .fc-more-cell {
    pointer-events: none;
  }
`}
`

const EventListArea: StyledDiv = styled.div`
  margin: 10px 0 10px 0;
  border: 1px solid grey;
  border-radius: 8px;
`

const EventListNone: StyledDiv = styled.div`
  padding: 0 0 0 10px;
`

const EventList: StyledDl = styled.dl`
  margin-top: 0;
  position: relative;
  padding: 0 0 0 10px;
`

const EventCategory: StyledDt = styled.dt`
  margin: 0;
  font-weight: ${FontWeights.Bold};
`

const EventTitle: StyledDd = styled.dd`
  margin: 0;
`

const EventListTitle: StyledDiv = styled.div`
  margin: 10px 10px 10px 10px;
  border-bottom: 1px solid grey;
`

const EventListInfo: StyledDiv = styled.div`
  margin: 10px 0 10px 0;
`

interface EventCategoryProps {
    categoryId: string;
    color: string
}

const EventCategoryIcon = styled.i<EventCategoryProps>`
  ${IconFont};
  font-size: 3.0rem;
  margin-right: 5px;
  color: ${Colors.Surface};
  background-color: ${(props: EventCategoryProps) => props.color};
  border-radius: 3px;

  &::before {
    ${(props: EventCategoryProps) => getEventCategoryIcon(props)};
  }
`

const getEventCategoryIcon = (props: EventCategoryProps) => {
    if (props.categoryId === EVENT_CATEGORY.TRASH_DAY.value) {
        return `content: "\f11d"`
    } else if (props.categoryId === EVENT_CATEGORY.MAINTENANCE.value) {
        return `content: "\f127"`
    } else if (props.categoryId === EVENT_CATEGORY.CLEANING.value) {
        return `content: "\f10e"`
    } else if (props.categoryId === EVENT_CATEGORY.OTHER_EVENT.value) {
        return `content: "\f12f"`
    } else if (props.categoryId === EVENT_CATEGORY.OTHER.value) {
        return `content: "\f12f"`
    }
}

const CategorySelect: StyledSelect = styled(DisplayItemSelect)`
  width: 100%
`
const CategorySelectIcon = styled(DisplayItemSelectIcon)`
  &:after {
    right: 5%;
  }
`
